import type {
    ComposableOptionsBase,
    FullImageGeneratedSizes
} from '~/types';
import type { ImageSizeTypes } from '~/models';

export interface UseProductImageUtilsOptions extends ComposableOptionsBase {}
export interface UseProductImageUtilsOptionsRequired {
    fallbackImgUrl: MaybeRef<string>;
}
export function useProductImageUtils(options: Partial<UseProductImageUtilsOptions> & UseProductImageUtilsOptionsRequired) {

    function getFirstPreferredSize(sizesObj: FullImageGeneratedSizes, types: ImageSizeTypes[]): string {
        let img: string = unref(options.fallbackImgUrl);

        for (let i = 0; i < types.length; i++) {
            const t = types[i];

            if (t && sizesObj.sizesMap[t]) {
                img = sizesObj.sizesMap[t]!;
                break;
            }
        }
    
        return img;
    }

    function getImagesForBg(sizesObj: FullImageGeneratedSizes, types: ImageSizeTypes[]): string {
        const imgSetStr = types.reduce((acc: string[], type: ImageSizeTypes, idx: number) => {
            const size = sizesObj.sizesMap[type];

            if (size) {
                acc.push(`url(${size}) ${idx + 1}x`);
            }

            return acc;
        }, []);

        if (imgSetStr.length) {
            return imgSetStr.join(',');
        }

        return `url(${unref(options.fallbackImgUrl)}) 1x`;
    }

    return {
        getFirstPreferredSize,
        getImagesForBg
    };
}
